// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3FaAg","productName":"Table_productName__3bIJ2"};